import {Pipe, PipeTransform} from '@angular/core';
import {formatDayKey} from './company-day';

/**
 * Shows a calendar day (`yyyy-MM-dd`) as German users read it: `{{ contract.validTo | dayKey }}` gives `30.09.2026`,
 * and `| dayKey:'long'` gives `30. September 2026`. Use it instead of the `date` pipe for a field that is a day
 * rather than a moment (see {@link formatDayKey}).
 */
@Pipe({name: 'dayKey'})
export class DayKeyPipe implements PipeTransform {
  transform(value: unknown, style: 'short' | 'long' = 'short'): string {
    return formatDayKey(value, style);
  }
}
